import api from './api';

export const GetPostsResumosExtendido = async () => {

    try {
        let resposta = await api.get(`getpostsresumosextendido`);
        let posts = resposta.data;

        return posts;
    } catch (error) {

            return error.response;

    }
};
